export class Result204<T>
{
    constructor (public value: T, public noContent: boolean)
    {
    }
}
